import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles<Theme>((theme) => ({
  popover: {
    zIndex: zIndexes.broadcastMenuZIndex + 1,
  },
  popoverContainer: {
    overflow: "hidden",
    backgroundColor: "#1c1f2f",

    "&::after": {
      content: "",
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "10px 10px 0 10px",
      borderColor: "#1c1f2f transparent transparent transparent",
    },
  },
  popoverItem: {
    padding: 0,
  },
  container: {
    alignItems: "center",
    pointerEvents: "all",
    width: "100%",
    marginTop: "5px",
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: "var(--EventsDarkBlack)",
  },
  mobileContainer: {
    backgroundColor: theme.palette.background.default,
    alignItems: "center",
  },
  push: {
    [theme.breakpoints.up("sm")]: {
      marginRight: "auto",
    },
  },
  mobileLast: {
    order: 10,
    [theme.breakpoints.up("sm")]: {
      order: "unset",
    },
  },
  divider: {
    backgroundColor: "var(--EbonyClay3)",
    height: "46px",
    margin: "0 10px",
    alignSelf: "flex-start",
  },
  toolbar: {
    justifyContent: "center",

    [theme.breakpoints.up("xl")]: {
      position: "absolute",
      left: "50%",
      transform: "translate(-50%)",
    },
  },
  hideOnMobile: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "unset",
    },
  },
  helpChatButton: {
    order: 10,
    height: "46px",
    width: "46px",
    minWidth: "46px",

    backgroundColor: "var(--EventsLightBlack)",

    "&:hover": {
      backgroundColor: "#efefef26",
    },
  },
}));
